import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { isDemoEnvironment } from '../../../constants/global';
import { handleGql403 } from '../../../utils';
import { CloneCampaignByIdMutation, MutationCloneCampaignByIdArgs } from '../types';
import { CLONE_CAMPAIGN_BY_ID } from './cloneCampaignByID';

type CampaignClonedItem = {
  id: string;
};

export type UseCloneLineItemByID = {
  fetchCloneCampaignByID: (campaignId: string) => Promise<CampaignClonedItem | undefined>;
  loading: boolean;
};

const useCloneCampaignByID = (): UseCloneLineItemByID => {
  const [cloneCampaignByID, { loading }] = useMutation<CloneCampaignByIdMutation, MutationCloneCampaignByIdArgs>(
    CLONE_CAMPAIGN_BY_ID
  );

  const fetchCloneCampaignByID = useCallback(
    async (campaignId: string): Promise<CampaignClonedItem | undefined> => {
      if (isDemoEnvironment) {
        return Promise.resolve({ id: '' });
      }

      const { data } = await cloneCampaignByID({
        variables: {
          campaignId,
        },
        onError: handleGql403,
      });

      return data?.cloneCampaignByID;
    },
    [cloneCampaignByID]
  );

  return {
    fetchCloneCampaignByID,
    loading,
  };
};

export default useCloneCampaignByID;
